import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useTranslation } from 'react-i18next';

export const FormField: React.FC<{
  id: string;
  label: string;
  name: string;
  value: string;
  placeholder: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isInvalid: boolean;
  errorMessage: string | null;
  className?: string;
  height?: string;
  required?: boolean;
  maxLength?: number;
}> = ({
  id,
  label,
  name,
  value,
  placeholder,
  onBlur,
  onChange,
  isInvalid,
  errorMessage,
  className,
  height = '40px', // Default height is 40px
  required = false,
  maxLength,
}) => {
  const { t } = useTranslation();

  return (
    <div className={`field mb-5 ${className}`}>
      <div className="flex align-items-center justify-content-between">
        <label className="font-bold block mb-2">
          {t(label)}
          {required && <span className="p-error"> *</span>}
        </label>
        {maxLength && (
          <small className="text-color-secondary">
            {value.length}/{maxLength}
          </small>
        )}
      </div>
      <InputText
        id={id}
        placeholder={t(placeholder)}
        name={name}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        maxLength={maxLength}
        className={classNames({ 'p-invalid': isInvalid })}
        style={{ height }} // Set height dynamically using the prop
      />
      {isInvalid && (
        <div className="flex align-items-center justify-content-start mt-1 mx-2">
          <small className="p-error">*{t(errorMessage)}</small>
        </div>
      )}
    </div>
  );
};
